import { render, staticRenderFns } from "./ContactAvatar.vue?vue&type=template&id=d44633a4&"
import script from "./ContactAvatar.vue?vue&type=script&lang=js&"
export * from "./ContactAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports